import { isAboveDesktop } from "../utils/breakpoints";
import gtm from "../utils/GTM";

const HeaderSearch = (function () {
  const header = document.querySelector("header");

  const expandableHeaderBackground = document.querySelector<HTMLElement>(
    ".js-expandable-header-background",
  );
  const searchMainClass = "js-menu-search-wrapper";
  const searchButtonClass = "js-menu-search-button";
  const headerSearchIsOpen = "search-is-open";
  const headerMenuIsOpen = "menu-is-open";

  const searchMain = document.querySelector<HTMLElement>(`.${searchMainClass}`);
  const searchButton = document.querySelector<HTMLElement>(
    `.${searchButtonClass}`,
  );
  const searchReset = document.querySelector(".js-menu-search-reset");
  const searchInput = document.querySelector<HTMLElement>("#menu-search");

  const eventOpenSearch = new Event("openSearch");
  const eventCloseMenu = new Event("closeMenu");
  const eventCloseSearch = new Event("closeSearch");

  function openSearch() {
    gtm.datalayerPush("search_open");
    header?.classList.add(headerSearchIsOpen);

    if (header?.classList.contains(headerMenuIsOpen)) {
      header.dispatchEvent(eventCloseMenu);
    }
    if (isAboveDesktop()) {
      if (expandableHeaderBackground) {
        expandableHeaderBackground.style.height = `${
          searchMain?.getBoundingClientRect().height
        }px`;
      }

      searchInput?.focus();
    } else {
      if (searchMain) searchMain.style.display = "block";
      searchInput?.focus();
    }
  }

  function closeSearch() {
    gtm.datalayerPush("search_close");
    header?.classList.remove(headerSearchIsOpen);
    if (isAboveDesktop()) {
      if (expandableHeaderBackground) {
        expandableHeaderBackground.style.height = "0";
      }
    } else {
      if (searchMain) searchMain.style.display = "none";
    }
    searchButton?.focus();
  }

  function addListeners() {
    if (!header) return;
    header.addEventListener("openSearch", openSearch);
    header.addEventListener("closeSearch", closeSearch);
    header.addEventListener("keydown", function (e: KeyboardEvent) {
      if (e.key === "Escape") closeSearch();
    });

    searchButton?.addEventListener("click", function () {
      if (!header.classList.contains(headerSearchIsOpen)) {
        header.dispatchEvent(eventOpenSearch);
      } else {
        header.dispatchEvent(eventCloseSearch);
      }
    });

    searchReset?.addEventListener("click", function () {
      searchInput?.focus();
    });

    document.addEventListener("click", function (e) {
      const target = e.target as Element | null;
      if (
        header.classList.contains(headerSearchIsOpen) &&
        !header.classList.contains(headerMenuIsOpen)
      ) {
        if (
          target?.closest(`.${searchMainClass}`) === null &&
          target?.closest(`.${searchButtonClass}`) === null
        ) {
          header.dispatchEvent(eventCloseSearch);
        }
      }
    });

    searchMain?.addEventListener("focusout", function () {
      setTimeout(function () {
        const focused = document.activeElement;
        if (!focused) return;
        if (
          focused.closest(`.${searchMainClass}`) === null &&
          !focused.matches(`.${searchButtonClass}`) &&
          !focused.matches("body")
        ) {
          header.dispatchEvent(eventCloseSearch);
        }
      }, 10);
    });
  }

  function init() {
    addListeners();
  }

  return {
    init,
  };
})();

export default HeaderSearch;
